import React from "react";
import ProfileImageUploader from "../../components/Employee/Profile/ProfileImageUploader";
import sampleUser from "../../assets/user.jpg";

export default function ProfileHeader({ profile, setProfile }) {
  if (!profile) return null; // Avoid crash while loading

  return (
    <div className="profile-header">
      <div className="profile-picture-section">
        <ProfileImageUploader
          image={profile.profileImage || sampleUser}
          onChange={({ previewUrl, file }) =>
            setProfile((prev) => ({
              ...prev,
              profileImage: file || previewUrl,
            }))
          }
        />
      </div>

      <div className="profile-header-details">
        <h2>
          {profile.firstName} {profile.lastName}
        </h2>
        <p>{profile.email}</p>
        <span>{profile.position || "No Position Available"}</span>
      </div>
    </div>
  );
}
